module.exports = __webpack_public_path__ + "static/img/film.c2ea3e63.svg";